import StatusCard from '@/components/StatusCard';
import { getLastVisitedRoute } from '@/utils/lastVisitedRoute';

export default function NotFound() {
  return (
    <StatusCard
      title="Page Not Found"
      message={<>The page you are looking for doesn&apos;t exist.<br />It may have moved, or the link may be out of date.</>}
      actions={[{
        label: 'Back to Previous Page',
        // Return the user to the page they were on before this one, which is the whole
        // point of tracking it. Still read at click time rather than render time: the
        // value can change while this page is on screen, and reading it late costs
        // nothing.
        // '/' is the last resort, not '/overview': overview is gated on hasOverviewAccess
        // and dead-ends anyone without it, while '/' is public and routes by permission.
        onClick: () => { window.location.href = getLastVisitedRoute() || '/'; },
      }]}
    />
  );
}
